import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HeaderActionsComponent } from '../../header-actions/header-actions.component';
import { ActingPostService } from '../../../../core/auth/acting-post.service';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-global-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    HeaderActionsComponent
  ],
  templateUrl: './global-header.html',
  styleUrls: ['./global-header.scss'],
})
export class GlobalHeaderComponent {
  @Input() moduleTitle: string = 'RKUMP Module';
  // Every layout passes this as `!hideSidebar()` — false for the same
  // full-screen flows (notifications, the generic voucher list/detail
  // screens, etc.) where the module icon/title is noise too, so it doubles
  // as that signal rather than the header re-deriving route state itself.
  @Input() showMenuToggle: boolean = true;
  @Output() toggleSidebar = new EventEmitter<void>();

  /** Drives the "Acting as: X" indicator — visible only once a posting has
   * been confirmed for this session and the feature is on (spec §12 step 4). */
  protected readonly actingPost = inject(ActingPostService);

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }
}
